export default {
  examDetail_total: '总分',
  examDetail_pass_score: '及格分',
  examDetail_exam_time: '考试时间',
  examDetail_score: "成绩",
  examDetail_pass_or_not: "是否通过",
  examDetail_not_yet: '暂无',
  examDetail_in_marking: '阅卷中',
  examDetail_passed: '已通过',
  examDetail_failed: '未通过',
  examDetail_submit_marking_tip: '交卷成功，老师正在阅卷中',
  examDetail_passed_exam_tip: '恭喜你！考试通过啦',
  examDetail_failed_tip: '很遗憾，这次没有通过，再接再厉吧',
  examDetail_test_again: '再考一次',
  examDetail_check_score: "阅卷完成后，再次进入考试即可查看成绩",
  examDetail_check_wrong: "查看错题",
  examDetail_check_certificate: "查看证书",
  examDetail_my_answers: "我的答案：",
  examDetail_no_answer: '未作答',
  examDetail_correct_answer: "正确答案：",
  examDetail_camera_invigilate: '请允许启用摄像头进行监考',
  examDetail_camera_unusual: '摄像头异常，进入考试失败',
  examDetail_allow_camera: '请点击“允许”开启监考摄像头',
  examDetail_invigilating: '监考中',
  allow_camera: '点击开启摄像头',
  examDetail_submit_failed: '网络异常，交卷失败',
  examDetail_overtime: '已超过考试结束时间10分钟以外，考试无效',
  examDetail_next_step: '跳转下一题后将无法再修改本题，确定进入下一题吗？',
  examDetail_not_prompt_again:"不再提示",
  examDetail_determine: '确定（15s）',
  examDetail_time_limit: '本题限时{nowLimitTime}秒',
  examDetail_unchangeable: '本题已提交，不可修改',
  examDetail_submit_exam_page: "交卷",
  examDetail_previous: '上一题',
  examDetail_next: '下一题',
  examDetail_no_mistake: '暂无错题',
  examDetail_limitTip: '最多上传{limit}个附件',
  examDetail_not_allow_special_symbols: '附件题附件不支持文件名含特殊符号',
  examDetail_limit_size: '单个文件不能超过{size}M，请重新选择',
  examDetail_not_allow_empty: '不能上传空文件，请重新选择',
  examDetail_upload_attachment_tip: '请上传附件完成作答（最多支持上传三个附件，每个不超过{size}M）',
  examDetail_clean_up: '清空',
  examDetail_revoke: '撤销',
  examDetail_lineTips: '提示：请从左至右连线，左侧可连接多个右侧选项',
  examDetail_clearTip: '确定要清空连线吗',
  examDetail_referAnswer: '参考答案',
  examDetail_enter_answer: '请在此输入答案',
  examDetail_uploadImageTip: '最多支持上传9张图片，格式支持：JPG/PNG/JPEG，每个文件大小不超过5M。',
  examDetail_uploadImage: '上传图片',
  examDetail_prompt_tip: "查看提示",
  examDetail_download_exam: '下载附件考题',
  examDetail_tip_info: '提示信息：',
  examDetail_not_supported_audio: '您的浏览器暂不支持播放音频文件',
  examDetail_try_later_audio: '语音转换还未完成，请稍后尝试！',
  examDetail_voice_loading: '语音加载中，请稍后尝试！',
  examDetail_voice_reading: '语音读题',
  examDetail_history_results: '历史成绩',
  examDetail_open_time: '开放时间：',
  examDetail_format_time: 'YYYY年M月D日 HH:mm',
  examDetail_no_limit_time: '不限时间',
  examDetail_exam_num: '考试次数：',
  examDetail_remainTimes: '您还有{remianingNum}次考试机会',
  examDetail_no_limit_num: '不限考试次数',
  examDetail_exam_careful: '考试注意：',
  examDetail_attentionItem: '开始考试后，请不要关闭浏览器或跳出窗口，否则系统将判定考试结束。',
  examDetail_invigilation_mode: '监考模式：',
  examDetail_invigilateItem: '参加考试需要通过身份认证',
  examDetail_exam_marking: '考试阅卷中',
  examDetail_scoreText: "考试{isPassed}通过，获得最高得分{highestScore}分",
  examDetail_already:"已",
  examDetail_not_yet:"未",
  examDetail_highestScore: '获得最高得分{highestScore}分',
  examDetail_testNumTxt: '考试数量',
  examDetail_exam_duration: '考试时长',
  examDetail_minute: '分钟',
  examDetail_unlimited: '不限',
  examDetail_exam_start: '开始考试',
  examDetail_exam_no_start: '考试尚未开始',
  examDetail_exam_end: '考试已结束',
  examDetail_exam_complete: '考试完成',
  examDetail_exam_registration: '考试报名',
  examDetail_exam_again: '再考一次',
  examDetail_under_review: '报名审核中',
  examDetail_info_submited: '报名信息已提交，请等待老师审核',
  examDetail_go_from_app: '暂不支持，请从APP进入',
  examDetail_forbidden_enter:'已达到截屏最大次数，禁止再次进入考试，请联系管理员解封',
  examDetail_face_recognition:"请先开通人脸识别",
  examDetail_face_recognition_tip:"该考试要求考生开通人脸识别监考，您还未开通人脸识别功能，请先开通",
  examDetail_photograph:'拍照',
  examDetail_remake:'重拍',
  examDetail_uploading:'上传中',
  examDetail_upload:'上传',
  examDetail_certification_passed:'认证通过',
  examDetail_info_enter_success:'信息录入成功',
  examDetail_take_picture:'请面对镜头，点击拍照',
  examDetail_imgUpload:'拍摄完成，请点击上传',
  examDetail_being_uploaded_review:'照片正在上传审核中...',
  examDetail_time_over:'本次考试共{questionNum}题，考试时间到，是否确认交卷',
  examDetail_continue_submit:'继续交卷（{time}）',
  examDetail_remaining_time:'剩余考试时间：',
  examDetail_exam_total:'本次考试共{total}题',
  examDetail_not_answer:'未答：',
  examDetail_answered:'已答：',
  examDetail_hasNoAnswer:'本次考试共{questionAnswers}题，已答共{yesArr}题，未答共{noArr}题，是否确定交卷？',
  examDetail_all_complete:'本次考试共{questionAnswers}题，你已经全部答完，是否确定交卷？',
  examDetail_go_back_continue:'返回继续作答',
  examDetail_reference_answer_colon:'参考答案：'
}
